/*! JointJS+ v4.0.1 - HTML5 Diagramming Framework

Copyright (c) 2024 client IO

 2024-04-11 


This Source Code Form is subject to the terms of the JointJS+ License
, v. 2.0. If a copy of the JointJS+ License was not distributed with this
file, You can obtain one at https://www.jointjs.com/license
 or from the JointJS+ archive as was distributed by client IO. See the LICENSE file.*/


import { createStore, applyMiddleware } from 'redux';

import reducer from './reducer';
import { sideEffects } from './middleware';

export default createStore(reducer, applyMiddleware(sideEffects));
